// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.company.RentalManagerUserManagementCompanyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerUserCompanyStatsDto,
  RentalManagerUserProfilesDto,
  RentalManagerUserProfileUpdateRequestDto,
  RentalManagerUserPropertyDetailsListDto,
  UserManagementCompanyPropertyDetailsListDto,
  Zuid,
} from '../..';

interface GetCompanyListingsForUserParams {
  zuid: Zuid;
}
interface GetPendingProfileParams {
  email: string;
}
interface GetPendingUserPropertiesParams {
  email: string;
}
interface GetUserProfilesParams {
  /**
   * @deprecated
   */
  userBrand?: string;
  userToken?: string;
}

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path =
  '/api/web/v1/users/company/getCompanyListingsForUser';

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser = (
  getParams: GetCompanyListingsForUserParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompanyListingsForUserParams, never, UserManagementCompanyPropertyDetailsListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path =
  '/api/web/v1/users/company/getPendingProfile';

/**
 * Get an invited user's pending profile
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile = (
  getParams: GetPendingProfileParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPendingProfileParams, never, RentalManagerUserProfilesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path =
  '/api/web/v1/users/company/getPendingUserProperties';

/**
 * Get a pending user's properties
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties = (
  getParams: GetPendingUserPropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPendingUserPropertiesParams, never, RentalManagerUserPropertyDetailsListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path =
  '/api/web/v1/users/company/getUserCompanyStats';

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserCompanyStatsDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path =
  '/api/web/v1/users/company/getUserManagementProfiles';

/**
 * Get the current user's company users
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserProfilesDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path =
  '/api/web/v1/users/company/getUserProfiles';

/**
 * Get user profiles including feature access and properties permissions
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles = (
  getParams: GetUserProfilesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserProfilesParams, never, RentalManagerUserProfilesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Path =
  '/api/web/v1/users/company/updateUserSettings';

/**
 * Update existing user settings
 */
export const RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings = (
  postData: RentalManagerUserProfileUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerUserProfileUpdateRequestDto, void>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
